import axios from 'axios';
import { REST_BASE } from './applicationTemplates';

/**
 * Lekeplassen: ansatte hos stiftelsen kan gå gjennom søknads- og
 * rapportskjemaene uten å opprette noe. Tilgangen avgjøres av lyfti-api
 * (`GET /rest/playground`), som krever en rolle hos stiftelsen —
 * `user.admin` fra `getUserData` er bare «har en admin-konto et sted».
 */

/** Samme vertsoppslag som NewApplicationProvider bruker mot REST. */
export const currentHostname = (): string =>
    localStorage.getItem('lyfti_selected_entity') || window.location.hostname;

// Ett kall per (sub, vert) i økta: fanen på Din side og vakten rundt
// lekeplass-rutene spør begge.
const accessCache = new Map<string, Promise<boolean>>();

export function fetchPlaygroundAccess(sub: string): Promise<boolean> {
    if (!REST_BASE || !sub) return Promise.resolve(false);

    const hostname = currentHostname();
    const key = `${sub}|${hostname}`;
    const cached = accessCache.get(key);
    if (cached) return cached;

    const request = axios
        .get(`${REST_BASE}/playground?sub=${encodeURIComponent(sub)}&hostname=${encodeURIComponent(hostname)}`, {
            headers: { Accept: 'application/json' },
        })
        .then((res) => res.data?.data?.access === true)
        .catch((error) => {
            // Et nei (401/403) gjelder resten av økta; en nettverksfeil eller
            // 5xx skal prøves på nytt ved neste visning.
            const status = axios.isAxiosError(error) ? error.response?.status : undefined;
            if (status !== 401 && status !== 403) accessCache.delete(key);
            return false;
        });

    accessCache.set(key, request);
    return request;
}
